import React, { Component } from "react"
import { Table, Icon, message, Row } from "antd"
import "./Index.scss"
import { observer, inject } from "mobx-react"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { PREPARE_RUN, RUNNING, FAIL, SUCCESS } from 'app/utils/const'

@inject("entrance", "auth", "azfReport") @observer
export default class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      downLoadModal: false,
      showEditModal: false,
      dataIndex: 0,
      options: [],
      editGroupName: "",
      groupNameHistory: [],
    }
  }

  showEditModal = () => {
    const { data, azfReport: { getGroupListById } } = this.props

    this.setState({
      showEditModal: true,
      editGroupName: data.groupName
    })
    getGroupListById(data.groupId, "deleted")
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  recoveryGroup = (id) => {
    const { store: { recoveryGroup, tableData }, groupIndex } = this.props
    recoveryGroup(id)
      .then(
        res => {
          tableData.splice(groupIndex, 1)
          message.success("家系恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  renderGroupButtons = () => {
    let { data = {} } = this.props

    return (
      <Row
        type="flex"
        align="middle"
        justify="center"
        className="info-buttons"
      >
        <Row
          type="flex"
          align="middle"
          className="recovery-family"
          onClick={() => this.recoveryGroup(data.groupId)}
        >
          <img src={recoveryIcon} alt="" /> 恢复家系报告
        </Row>
      </Row>
    )
  }

  copyText = (content) => {
    let targetId = "_hiddenCopyText_"
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = content
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  toggleGroupNameHistory = (visible) => {
    if (visible) {
      //调接口
      const { store: { getReportHistory }, data: { groupId } } = this.props
      getReportHistory(groupId)
        .then(
          res => {
            this.setState({
              groupNameHistory: res
            })
          },
          err => {
            message.error("历史记录获取失败")
          }
        )
    } else {
      this.setState({
        groupNameHistory: []
      })
    }
  }

  checkOperatable = (record) => {
    return record.state !== RUNNING && record.state !== PREPARE_RUN
  }

  render() {
    const { data = {} } = this.props
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }

      if (
        record.state === PREPARE_RUN
        || record.state === RUNNING
        || record.state === FAIL
      ) {
        obj.props.colSpan = 0
      }
      return obj
    }
    const columns = [
      {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          const { queryMap: { keywords } } = this.props.store

          return (
            <MaterialTip title={text}>
              <div className="sample-name ellipsis">
                <Highlighter
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text || ""}
                />
              </div>
            </MaterialTip>
          )
        }
      }
    ]

    if (data.reportList) {  // 新建组传文件且文件正在运行会没有reportList字段从而报错
      const statistical = [
        {
          title: "Total_bases",
          className: "ta-r",
          dataIndex: "totalBases",
          render: (text, record, index) => {
            const stateData = [
              {
                text: "数据准备运行",
                className: "pre-run azf-state-element"
              },
              {
                text: "数据正在运行",
                className: "running azf-state-element"
              },
            ]
            // if (record.qualityState === CONTROL_FAIL_QUALITY) {
            //   return {
            //     children: (
            //       <Row type="flex" justify="center">
            //         <div className="azf-state-element qc-failed">
            //           <img className="warning-icon" alt="" src={warningIcon} />
            //           {record.qualityContent}
            //         </div>
            //       </Row>
            //     ),
            //     props: {
            //       colSpan: 9
            //     }
            //   }
            // }

            switch (record.state) {
              case PREPARE_RUN:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[0].className}>
                        <Icon type="hourglass" />
                        {stateData[0].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case RUNNING:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[1].className}>
                        <Icon type="clock-circle-o" />
                        {stateData[1].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case FAIL:
                return {
                  children: (
                    <Row type="flex" justify="center">
                      <div className="pgs-state-element run-failed">
                        <Icon type="close-circle" />
                        数据运行失败，
                      <div className="failed-button" onClick={() => this.copyText(record.reportId)}>
                          点击复制错误信息
                      </div>
                      发送给管理员，将尽快为您解决问题。
                    </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case SUCCESS:
                return (<div>{text}</div>)
              default:
                return (<div>{text}</div>)
            }
          }
        }, {
          title: "Dup_bases",
          className: "ta-r",
          dataIndex: "dupBases",
          render: renderContent
        }, {
          title: "Mapped_bases",
          className: "ta-r",
          dataIndex: "mappedBases",
          render: renderContent
        }, {
          title: "Target_bases",
          className: "ta-r",
          dataIndex: "targetBases",
          render: renderContent
        },
        {
          title: "Target_mean_depth",
          className: "ta-r",
          dataIndex: "targetMeanDepth",
          render: renderContent
        },
        {
          title: "Target_cov_1x",
          className: "ta-r",
          dataIndex: "targetCov1x",
          render: renderContent
        },
        {
          title: "Target_cov_10x",
          className: "ta-r",
          dataIndex: "targetCov10x",
          render: renderContent
        },
        {
          title: "Target_cov_20x",
          className: "ta-r",
          dataIndex: "targetCov20x",
          render: renderContent
        },
        {
          title: "Target_cov_30x",
          className: "ta-r",
          dataIndex: "targetCov30x",
          render: renderContent
        }
      ]
      columns.push(...statistical)
    }

    return (
      <Row type="flex" className="recycle-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" align="middle" className="info-group">
                <label>数据类型：</label><div className="text-content">{data.appGroupName.toUpperCase()}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>批次号：</label>
                <div className="text-content">
                  {data.groupName}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>样本数量：</label><div className="text-content">{data.totalDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label><div className="text-content">{data.createTime}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>删除时间：</label><div className="text-content">{data.deleteTime}</div>
              </Row>
            </div>
            {
              this.renderGroupButtons()
            }
          </div>
        </div>
        <Table
          columns={columns}
          className="recycle-card-content"
          rowKey={record => record.reportId}
          dataSource={data.reportList.slice()} pagination={false} />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/ecs/RecycleCard/index.js